export default {
	data() {
		return {
			// 全局混入，插入链接参数
			option: null,
            info:null,//用户个人信息
            inviteId:'',//推荐人
            version:1,//版本号
		}
	},

	computed: {},
	methods: {
    isEmpty(val){
      if (val instanceof Array) {
        if (val.length === 0) return true;
      } else if (val instanceof Object) {
        if (!Object.keys(val).length) return true;
      } else {
        if (
          val === "null" ||
          val === null ||
          val === "undefined" ||
          val === undefined ||
          val === ""
        )
          return true;
        return false;
      }
      return false;
    },
	},
	mounted() {}
}



// WEBPACK FOOTER //
// ./src/mixins/globalMixins.js